import FormControlledDropdown from '../../../components/inputs/FormInputs/FormControlledDropdown'; 
import { Status } from '../../../Interfaces/system/Generic.interfaces';

export type PolicyFiltersOptions = {
  policyStatus: Status;
};

export const POLICY_STATUS = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
  { label: 'Both', value: 'both' },
];

const PolicyFilters = () => {
  return (
    <div className="col">
      <FormControlledDropdown
        formID="policyStatus"
        defaultValue="active"
        options={POLICY_STATUS}
        labelField="label"
        valueField="value"
        placeholder="Select policy state"
        clearable={false}
      />
    </div>
  );
};

export default PolicyFilters;
